import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_DATA_API_KEY,
  authDomain: process.env.REACT_APP_DATA_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATA_DATABASE_URL,
  projectId: process.env.REACT_APP_DATA_PROJECT_ID,
  storageBucket: process.env.REACT_APP_DATA_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_DATA_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_DATA_APP_ID
};

const app = initializeApp(firebaseConfig);
